import { p as proxyCustomElement, H, c as createEvent, h, a as Host } from './index.js';
import { d as defineCustomElement$9 } from './p-DvxzXrZp.js';
import { d as defineCustomElement$8 } from './p-CgjIzafk.js';
import { d as defineCustomElement$7 } from './p-C78HRAnj.js';
import { d as defineCustomElement$6 } from './p-DKss2Fy6.js';
import { d as defineCustomElement$5 } from './p-xjpL7DAY.js';
import { d as defineCustomElement$4 } from './p-CHrkRM8Q.js';
import { d as defineCustomElement$3 } from './p-Dpg01lBi.js';
import { d as defineCustomElement$2 } from './p-Cr5d_5Z4.js';
import { d as defineCustomElement$1 } from './p-CZA0kb6w.js';

const paginationCss = ":host{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;align-items:center;background-color:var(--jw-theme-surface-tile-bg-color);box-sizing:border-box;display:flex;flex-wrap:wrap;font-family:Open Sans;font-size:.875rem;font-weight:400;gap:1rem;justify-content:space-between;letter-spacing:-.0004em;line-height:1.25rem;line-height:normal;padding:.75rem 1rem}:host *,:host :after,:host :before{box-sizing:inherit}:host img{flex:none;overflow:hidden;text-overflow:ellipsis;white-space:pre-line}";

const WuiPagination = /*@__PURE__*/ proxyCustomElement(class WuiPagination extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.changePageLength = createEvent(this, "changePageLength", 3);
        this.changePage = createEvent(this, "changePage", 3);
        /**
         * Is set to true as soon as total exceeds pageLength.
         *
         * Will not revert back to false.
         */
        this.autoVisible = false;
        this.handleChangePageLength = (event) => {
            event.preventDefault();
            event.stopPropagation();
            const newPageLength = event.detail;
            this.changePageLength.emit(newPageLength);
        };
        this.handleChangePage = (event) => {
            event.preventDefault();
            event.stopPropagation();
            const newPage = event.detail;
            this.changePage.emit(newPage);
        };
    }
    shouldRenderPagination() {
        if (this.paginationMode === 'off') {
            return false;
        }
        if (this.paginationMode === 'on') {
            return true;
        }
        if (this.paginationMode === 'auto') {
            // As soon as total exceeds page length just once: set the flag to keep the pagination visible.
            if (typeof this.total !== 'undefined' &&
                (this.total === Number.POSITIVE_INFINITY || (this.pageLength && this.total > 10))) {
                this.autoVisible = true;
            }
            return this.autoVisible;
        }
        // Default to true for unsupported modes
        return true;
    }
    render() {
        if (!this.shouldRenderPagination()) {
            return null;
        }
        return (h(Host, null, h("wui-table-page-length-input", { page: this.page, total: this.total, pageLength: this.pageLength, pageLengths: this.pageLengths, onChangePageLength: this.handleChangePageLength, disabled: this.loading || this.disabled }), h("wui-table-page-number-input", { page: this.page, total: this.total, pageLength: this.pageLength, onChangePage: this.handleChangePage, disabled: this.loading || this.disabled, hasError: this.hasError, itemsOnPage: this.itemsOnPage })));
    }
    static get style() { return paginationCss; }
}, [257, "wui-pagination", {
        "loading": [4],
        "disabled": [4],
        "hasError": [4, "has-error"],
        "paginationMode": [1, "pagination-mode"],
        "total": [2],
        "page": [2],
        "pageLength": [2, "page-length"],
        "pageLengths": [16, "page-lengths"],
        "itemsOnPage": [2, "items-on-page"],
        "autoVisible": [32]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["wui-pagination", "wui-button", "wui-divider", "wui-icon", "wui-layout", "wui-loader", "wui-table-page-length-input", "wui-table-page-number-input", "wui-tooltip", "wui-tooltip-label"];
    components.forEach(tagName => { switch (tagName) {
        case "wui-pagination":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, WuiPagination);
            }
            break;
        case "wui-button":
            if (!customElements.get(tagName)) {
                defineCustomElement$9();
            }
            break;
        case "wui-divider":
            if (!customElements.get(tagName)) {
                defineCustomElement$8();
            }
            break;
        case "wui-icon":
            if (!customElements.get(tagName)) {
                defineCustomElement$7();
            }
            break;
        case "wui-layout":
            if (!customElements.get(tagName)) {
                defineCustomElement$6();
            }
            break;
        case "wui-loader":
            if (!customElements.get(tagName)) {
                defineCustomElement$5();
            }
            break;
        case "wui-table-page-length-input":
            if (!customElements.get(tagName)) {
                defineCustomElement$4();
            }
            break;
        case "wui-table-page-number-input":
            if (!customElements.get(tagName)) {
                defineCustomElement$3();
            }
            break;
        case "wui-tooltip":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
        case "wui-tooltip-label":
            if (!customElements.get(tagName)) {
                defineCustomElement$1();
            }
            break;
    } });
}
defineCustomElement();

export { WuiPagination as W, defineCustomElement as d };
